class Controller {
  constructor($scope, $timeout) {
    "ngInject";

    this.$scope = $scope;
    this.$timeout = $timeout;
  }

  $onInit() {
    angular.element(window).on("scroll", this.checkingBreakPoint.bind(this));
  }

  checkingBreakPoint() {
    this.$scope.$apply(() => {
      const breakPoint = 64;
      const scrollValue = document.querySelector("html").scrollTop;
      if (scrollValue >= breakPoint) {
        this.breakPointReached = true;
      } else {
        this.breakPointReached = false;
      }
    });
  }

  scrollToTop() {
    const html = document.querySelector("html");
    html.scrollIntoView({
      behavior: "smooth",
    });
  }

  $onDestroy() {
    angular.element(window).off("scroll", this.checkingBreakPoint);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/backToTop/backToTop.controller.js